import React, { useEffect, useState } from 'react'
import { 
  components, 
  useTranslation,
  useServices 
} from 'cng-web-lib'
import { useHistory } from 'react-router'
import moment from 'moment-timezone'
import pathMap from '../../paths/pathMap'
import Table from '../../components/dashboardWidget/Table'
import ABITable from '../../components/dashboardWidget/ABITable'
import DoughnutChart from '../../components/dashboardWidget/DoughNutChart'
import ABIDoughNutChart from '../../components/dashboardWidget/ABIDoughNutChart'
import { getStatusMetadata, getStatusMetadataMini } from '../../common/NACommon'
import { Chip, Grid, Tooltip, Typography } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SummaryCargoTable from './QuickGlanceTable/SummaryCargoTable'
import SummaryShipmentTable from './QuickGlanceTable/SummaryShipmentTable'
import TprApiUrls from 'src/apiUrls/TprApiUrls'
import DashboardApiUrls from 'src/apiUrls/DashboardApiUrls'
import DashboardTranslationText from './context/DashboardTranslationText'
import { FileForUserGetUserDetails } from 'src/common/FileForUserCommon'

const {
  button: { CngButton },
  CngDialog,
} = components

function SummaryPage(props) {
  const history = useHistory()
  const { location: { pathname } } = props
  const {securedSendRequest } = useServices()

  // Default filter type for visibility check (matches original count API behavior)
  const DEFAULT_FILTER_TYPE = 'Last30Days'

  const [showAceHighway,setShowAceHighway] = useState(false)
  const [showAciHighway,setShowAciHighway] = useState(false)
  const [showEhbl,setShowEhbl] = useState(false)
  const [showISF10,setShowISF10] = useState(false)
  const [showAceOcean,setShowAceOcean] = useState(false)
  const [showAciOcean,setShowAciOcean] = useState(false)
  const [showFDAPN,setShowFDAPN] = useState(false)
  const [showWACM,setShowWACM] = useState(false)
  const [showAciAir,setShowAciAir] = useState(false)
  const [showAES,setShowAES] = useState(false)
  const [showABI,setShowABI] = useState(false)
  const [showABIQuery, setShowABIQuery] = useState(false)
  const [lookups, setLookups] = useState(null)

  const aciManifestTitle = 'ACI Manifests'
  const aciManifestSortedTitle = 'ACI Manifests (Sorted by submitted date)'
  const aceManifestTitle = 'ACE Manifests'
  const aceManifestSortedTitle = 'ACE Manifests (Sorted by submitted date)'

  const [clickedChartStatus, setClickedChartStatus] = useState({})
  const [quickGlanceDialog, setQuickGlanceDialog] = useState({ open: false, data: null, isAce: null })


  const translatedTextsObject = DashboardTranslationText()

    // Helper function to check transaction status and determine chart visibility
  const checkTransactionStatus = (endpoint, onSuccess) => {
    // Get file-for-user context (same logic as DoughnutChart component)
    let fileForUserDetails = FileForUserGetUserDetails();
    let partyId = (fileForUserDetails != null && fileForUserDetails != undefined) ? fileForUserDetails.fileForUserPartyId : null;

    // Use DEFAULT_FILTER_TYPE to match original count API behavior
    const requestParams = partyId != null 
      ? { filterType: DEFAULT_FILTER_TYPE, partyId } 
      : { filterType: DEFAULT_FILTER_TYPE }

    function onError(error) {
      console.error(`Get Transaction Status Error for ${endpoint}:`, error);
    }

    function onComplete() { }
    const config = {}

    // Use all-transaction-status API instead of broken count API
    // This API properly respects user context
    securedSendRequest.execute('POST', endpoint, requestParams, onSuccess, onError, onComplete, config, null);
  }

  useEffect(()=>{
      function onSuccess(response) {
        let data = response.data
        let moduleList = data.moduleList ? data.moduleList : []

        if(moduleList.length>0){
          moduleList.map((module)=> {
            let moduleCode = module.moduleCode.code;

            if(moduleCode == "ACE_HIGHWAY"){
              checkACEHighwayActiveTransaction()
            }

            if(moduleCode == "ACI_HIGHWAY"){
              checkACIHighwayActiveTransaction()
            }

            if(moduleCode == "EHBL"){
              checkEHBLActiveTransaction()
            }

            if(moduleCode == "ACE_ISF"){
              checkISF10ActiveTransaction()
            }

            if(moduleCode == "ACE_OCEAN"){
              checkACEOceanActiveTransaction()
            }

            if(moduleCode == "ACI_OCN"){
              checkACIOceanActiveTransaction()
            }

            if(moduleCode == "FDA_PN"){
              checkFDAPNActiveTransaction()
            }

            if(moduleCode == "WACM_MODULE"){
              checkWACMActiveTransaction()
            }

            if(moduleCode == "ACI_AIR"){
              checkACIAIRActiveTransaction()
            }

            if(moduleCode == "AES"){
              checkAESActiveTransaction()
            }

            if(moduleCode == "ABI"){
              checkABIActiveTransaction()
              checkABIQueryActiveTransaction()
            }

          })
        }
      }

      function onError(error) {
        console.log("Get Menu Priviledges Error: " + JSON.stringify(error));
      }

      function onComplete() { }
      const config = {}

      securedSendRequest.execute('POST', TprApiUrls.GET_USER_MENU_PRIVILEGES, {}, onSuccess, onError, onComplete, config, null);
  },[])

    function checkACEHighwayActiveTransaction(){
      function onSuccess(response) {
          let data = response.data

          if(data){
            // Check if dataMapping has any real records (excluding "NO RECORD" placeholder)
            const hasRecords = data.dataMapping && 
                              Object.keys(data.dataMapping).length > 0 &&
                              !data.dataMapping.hasOwnProperty("NO RECORD")
          
            if(hasRecords){
              setShowAceHighway(true)
              console.debug("ACE Highway has records - showing chart")
            } else {
              console.debug("ACE Highway has no records - hiding chart")
            }
          }
        }

        checkTransactionStatus(
          `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/dashboard/all-transaction-status`,
          onSuccess
        );
    }

    function checkACIHighwayActiveTransaction(){
      function onSuccess(response) {
          let data = response.data

          if(data){
            // Check if dataMapping has any real records (excluding "NO RECORD" placeholder)
            const hasRecords = data.dataMapping && 
                              Object.keys(data.dataMapping).length > 0 &&
                              !data.dataMapping.hasOwnProperty("NO RECORD")
          
            if(hasRecords){
              setShowAciHighway(true)
              console.debug("ACI Highway has records - showing chart")
            } else {
              console.debug("ACI Highway has no records - hiding chart")
            }
          }
        }

        checkTransactionStatus(
          `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/dashboard/all-transaction-status`,
          onSuccess
        );
    }


    function checkEHBLActiveTransaction(){
      function onSuccess(response) {
          let data = response.data

          if(data){
            // Check if dataMapping has any real records (excluding "NO RECORD" placeholder)
            const hasRecords = data.dataMapping && 
                              Object.keys(data.dataMapping).length > 0 &&
                              !data.dataMapping.hasOwnProperty("NO RECORD")
          
            if(hasRecords){
              setShowEhbl(true)
              console.debug("EHBL has records - showing chart")
            } else {
              console.debug("EHBL has no records - hiding chart")
            }
          }
        }

        checkTransactionStatus(DashboardApiUrls.EHBL_GET_ALL_TRANSACTION_STATUS, onSuccess);
    }

    function checkISF10ActiveTransaction(){
      function onSuccess(response) {
          let data = response.data

          if(data){
            // Check if dataMapping has any real records (excluding "NO RECORD" placeholder)
            const hasRecords = data.dataMapping && 
                              Object.keys(data.dataMapping).length > 0 &&
                              !data.dataMapping.hasOwnProperty("NO RECORD")
          
            if(hasRecords){
              setShowISF10(true)
              console.debug("ACE ISF10 has records - showing chart")
            } else {
              console.debug("ACE ISF10 has no records - hiding chart")
            }
          }
        }

        checkTransactionStatus(DashboardApiUrls.ISF10_GET_ALL_TRANSACTION_STATUS, onSuccess);
    }

    function checkACEOceanActiveTransaction(){
      function onSuccess(response) {
          let data = response.data

          if(data){
            // Check if dataMapping has any real records (excluding "NO RECORD" placeholder)
            const hasRecords = data.dataMapping && 
                              Object.keys(data.dataMapping).length > 0 &&
                              !data.dataMapping.hasOwnProperty("NO RECORD")
          
            if(hasRecords){
              setShowAceOcean(true)
              console.debug("ACE Ocean has records - showing chart")
            } else {
              console.debug("ACE Ocean has no records - hiding chart")
            }
          }
        }

        checkTransactionStatus(DashboardApiUrls.ACEOCN_GET_ALL_TRANSACTION_STATUS, onSuccess);
    }

    function checkACIOceanActiveTransaction(){
      function onSuccess(response) {
          let data = response.data

          if(data){
            // Check if dataMapping has any real records (excluding "NO RECORD" placeholder)
            const hasRecords = data.dataMapping && 
                              Object.keys(data.dataMapping).length > 0 &&
                              !data.dataMapping.hasOwnProperty("NO RECORD")
          
            if(hasRecords){
              setShowAciOcean(true)

              setLookups((prev) => ({
                ...(prev ?? {}),
                aciOcnDocFormat: ACI_OCEAN_DOC_FORMAT_MAP
              }));

              setLookups((prev) => ({
                ...(prev ?? {}),
                aciOcnCustomsProcedure: ACI_OCEAN_CUSTOMS_PROCEDURE_MAP
              }));

              setLookups((prev) => ({
                ...(prev ?? {}),
                aciOcnMessageFunction: ACI_OCEAN_MESSAGE_FUNCTION_MAP
              }));

              console.debug("ACI Ocean has records - showing chart")
            } else {
              console.debug("ACI Ocean has no records - hiding chart")
            }
          }
        }

        checkTransactionStatus(DashboardApiUrls.ACIOCN_GET_ALL_TRANSACTION_STATUS, onSuccess);
    }

    function checkFDAPNActiveTransaction(){
      function onSuccess(response) {
          let data = response.data

          if(data){
            // Check if dataMapping has any real records (excluding "NO RECORD" placeholder)
            const hasRecords = data.dataMapping && 
                              Object.keys(data.dataMapping).length > 0 &&
                              !data.dataMapping.hasOwnProperty("NO RECORD")
          
            if(hasRecords){
              setShowFDAPN(true)
            
              setLookups((prev) => ({
                ...(prev ?? {}),
                entryType: ENTRY_TYPE_MAP // directly set the object
              }));

              setLookups((prev) => ({
                ...(prev ?? {}),
                billType: BILL_TYPE_MAP // directly set the object
              }));

              console.debug("FDA PN has records - showing chart")
            } else {
              console.debug("FDA PN has no records - hiding chart")
            }
          }
        }

        checkTransactionStatus(DashboardApiUrls.FDAPN_GET_ALL_TRANSACTION_STATUS, onSuccess);
    }

    function checkWACMActiveTransaction(){
      function onSuccess(response) {
          let data = response.data

          if(data){
            // Check if dataMapping has any real records (excluding "NO RECORD" placeholder)
            const hasRecords = data.dataMapping && 
                              Object.keys(data.dataMapping).length > 0 &&
                              !data.dataMapping.hasOwnProperty("NO RECORD")
          
            if(hasRecords){
              setShowWACM(true)

              setLookups((prev) => ({
                ...(prev ?? {}),
                msgFunction: MESSAGE_FUNCTION_MAP // directly set the object
              }));

              setLookups((prev) => ({
                ...(prev ?? {}),
                wacmStatus: WACM_STATUS_MAP // directly set the object
              }));

              console.debug("WACM has records - showing chart")
            } else {
              console.debug("WACM has no records - hiding chart")
            }
          }
        }

        checkTransactionStatus(DashboardApiUrls.WACM_GET_ALL_TRANSACTION_STATUS, onSuccess);
    }

    function checkACIAIRActiveTransaction(){
      function onSuccess(response) {
          let data = response.data

          if(data){
            // Check if dataMapping has any real records (excluding "NO RECORD" placeholder)
            const hasRecords = data.dataMapping && 
                              Object.keys(data.dataMapping).length > 0 &&
                              !data.dataMapping.hasOwnProperty("NO RECORD")
          
            if(hasRecords){
              setShowAciAir(true)
              console.debug("ACI AIR has records - showing chart")
            } else {
              console.debug("ACI AIR has no records - hiding chart")
            }
          }
        }

        checkTransactionStatus(DashboardApiUrls.ACIAIR_GET_ALL_TRANSACTION_STATUS, onSuccess);
    }

    function checkABIActiveTransaction(){
      // Module privilege alone decides visibility. Zero counts on the default
      // range must not hide the widget - user needs it to switch to 7/30 days.
      setShowABI(true)
    }

    function checkABIQueryActiveTransaction(){
      setShowABIQuery(true)
    }

    function checkAESActiveTransaction(){
      function onSuccess(response) {
          let data = response.data

          if(data){
            // Check if dataMapping has any real records (excluding "NO RECORD" placeholder)
            const hasRecords = data.dataMapping && 
                              Object.keys(data.dataMapping).length > 0 &&
                              !data.dataMapping.hasOwnProperty("NO RECORD")
          
            if(hasRecords){
              setShowAES(true)
              console.debug("AES has records - showing chart")
            } else {
              console.debug("AES has no records - hiding chart")
            }
          }
        }

        checkTransactionStatus(DashboardApiUrls.AES_GET_ALL_TRANSACTION_STATUS, onSuccess);
    }

 function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  const combineDateAndTime = (date, time) => {
    if (date && time) {
      const dateTime = moment(date).set({
        hour: parseInt(time.substring(0, 2), 10),
        minute: parseInt(time.substring(2, 4), 10),
      });
      return dateTime.format('D MMM YYYY HH:mm');
    }
    return "";
  };

  function onChartElementClicked(element, title) {
    if (element && element.length) {
      const status = element[0]._view.label;

      if (title === aciManifestTitle) {
        setClickedChartStatus({ module: aciManifestSortedTitle, status: status })
      } else if (title === aceManifestTitle) {
        setClickedChartStatus({ module: aceManifestSortedTitle, status: status })
      }
    }
  }

  const aceManifestsTableCols = [
    {
      field: 'tripNum',
      filterType: 'string',
      title: 'Trip No.',
      render: (data) => {
        var status = data.status
        var recordId = data.manifestID
        var viewUrl = `/ace-highway/manifest/view/`+ recordId
        var editUrl = `/ace-highway/manifest/edit/`+ recordId

        return (
          <div style={{ 'text-decoration': 'underline', cursor: 'pointer' }}
            onClick={() => { status === "ST" ? history.push(viewUrl) : history.push(editUrl) }}>
            {data.tripNum}
            {data.reminderNote &&
              <Tooltip key='more' title={data.reminderNote} placement='top'>
                <Chip
                  icon={<FontAwesomeIcon fixedWidth icon={['fas', 'flag']} style={{ color: 'red' }} />}
                  size='small'
                  style={{ fontSize: 12, backgroundColor: 'transparent' }}
                />
              </Tooltip>
            }
          </div>
        )
      }
    },
    {
      field: 'status',
      filterType: 'checkbox',
      filterOptions: [
        { label: 'Accepted', value: 'AC' },
        { label: 'Rejected', value: 'RJ' },
        { label: 'Cancel Accepted', value: 'CL' },
        { label: 'Cancel Rejected', value: 'CR' },
        { label: 'Draft', value: 'DR' },
        { label: 'Status Notification', value: 'SN' },
        { label: 'Modification Rejected', value: 'MR' },
        { label: 'Sent', value: 'ST' },
        { label: 'Preliminary', value: 'PL' },
        { label: 'Trip Arrived', value: 'SN030' },
        { label: 'Trip Released', value: 'SN038' }
      ],
      title: 'Status',
      render: (data) => {
        const statusIndicator = data.statusIndicator ? data.statusIndicator : data.status
        const status = getStatusMetadata(statusIndicator)

        return (
          <Tooltip key='more' title='Quick glance at Shipment(s)' placement='top'>
            <Chip
              label={status.label}
              size='small'
              style={{ backgroundColor: status.color, color: status.contrastColor }}
              onClick={() => setQuickGlanceDialog({ open: true, data: data, isAce: true })}
            />
          </Tooltip>
        )
      }
    },
    {
      field: 'eta',
      title: 'ETA',
      render: (data) => data.eta && moment(data.eta).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'driverName',
      filterType: 'string',
      title: 'Driver'
    },
    {
      field: 'truck',
      filterType: 'string',
      title: 'Truck'
    },
    {
      field: 'trailer',
      filterType: 'string',
      title: 'Trailer'
    },
    {
      field: 'port',
      filterType: 'string',
      title: 'Port'
    }
  ]

  const aciManifestsTableCols = [
    {
      field: 'tripNum',
      filterType: 'string',
      title: 'Trip No.',
      render: (data) => {
        var status = data.status
        var recordId = data.manifestID
        var viewUrl = `/aci-highway/manifest/view/`+ recordId
        var editUrl = `/aci-highway/manifest/edit/`+ recordId

        return (
          <div style={{ 'text-decoration': 'underline', cursor: 'pointer' }}
            onClick={() => { status === "ST" ? history.push(viewUrl) : history.push(editUrl) }}>
            {data.tripNum}
            {data.reminderNote &&
              <Tooltip key='more' title={data.reminderNote} placement='top'>
                <Chip
                  icon={<FontAwesomeIcon fixedWidth icon={['fas', 'flag']} style={{ color: 'red' }} />}
                  size='small'
                  style={{ fontSize: 12, backgroundColor: 'transparent' }}
                />
              </Tooltip>
            }
          </div>
        )
      }
    },
    {
      field: 'status',
      filterType: 'checkbox',
      filterOptions: [
        { label: 'Accepted', value: 'AC' },
        { label: 'Rejected', value: 'RJ' },
        { label: 'Cancel Accepted', value: 'CL' },
        { label: 'Cancel Rejected', value: 'CR' },
        { label: 'Draft', value: 'DR' },
        { label: 'SN', value: 'SN' },
        { label: 'SN-Truck Arrived', value: 'SN-TA' },
        { label: 'SN-Goods Released', value: 'SN-GR' },
        { label: 'Modification Rejected', value: 'MR' },
        { label: 'Sent', value: 'ST' },
        { label: 'Arrived', value: 'AR' }
      ],
      title: 'Status',
      render: (data) => {
        const statusIndicator = data.statusIndicator ? data.statusIndicator : data.status
        const status = getStatusMetadata(statusIndicator)

        return (
          <Tooltip key='more' title='Quick glance at Cargo(s)' placement='top'>
            <Chip
              label={status.label}
              size='small'
              style={{ backgroundColor: status.color, color: status.contrastColor }}
              onClick={() => setQuickGlanceDialog({ open: true, data: data, isAce: false })}
            />
          </Tooltip>
        )
      }
    },
    {
      field: 'eta',
      title: 'ETA',
      render: (data) => data.eta && moment(data.eta).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'driverName',
      filterType: 'string',
      title: 'Driver'
    },
    {
      field: 'truck',
      filterType: 'string',
      title: 'Truck'
    },
    {
      field: 'trailer',
      filterType: 'string',
      title: 'Trailer'
    },
    {
      field: 'port',
      filterType: 'string',
      title: 'Port'
    }
  ]

  //ehbl column
  //1 - manifest id
  //2 - primary ccn
  //3 - status
  //4 - port of discharge
  //5 - port of destination
  //6 - hbl released indicator
  //7 - my reference number
  const ehblTableCols = [
    {
      field: 'column2',
      filterType: 'string',
      title: translatedTextsObject.primaryCCN,
      render: (data) => {
        var status = data.column3
        var recordId = data.column1
        var viewUrl = `/ehbl/manifest/view/`+ recordId
        var editUrl = `/ehbl/manifest/edit/`+ recordId

        return (
          <div style={{ 'text-decoration': 'underline', cursor: 'pointer' }}
            onClick={() => { status === "ST" ? history.push(viewUrl) : history.push(editUrl) }}>
            {data.column2}
          </div>
        )
      }
    },
    {
      field: 'column3',
      filterType: 'checkbox',
      filterOptions: [
      {
        label: translatedTextsObject.draft,
        value: 'DR'
      },
      {
        label: translatedTextsObject.accepted,
        value: 'AC'
      },
      {
        label: translatedTextsObject.sent,
        value: 'ST'
      },
      {
        label: translatedTextsObject.rejected,
        value: 'RJ'
      },
      {
        label: translatedTextsObject.statusNotification,
        value: 'SN'
      },
      {
        label: translatedTextsObject.cancellationAccepted,
        value: 'CL'
      },
      {
        label: translatedTextsObject.cancellationRejected,
        value: 'CR'
      },
      {
        label: translatedTextsObject.modificationRejected,
        value: 'MR'
      }
    ],
      title: translatedTextsObject.status,
      render: (data) => {

        //overwrite status from AC to 1000 to display Accepted status
        const statusIndicator = data.column3 === 'AC' ? '1000' : data.column3
        
        const status = getStatusMetadata(statusIndicator)

        return (
            <Chip
              label={status.label}
              size='small'
              style={{ backgroundColor: status.color, color: status.contrastColor }}
            />
        )
      }
    },
    {
      field: 'column4',
      filterType: 'string',
      title: translatedTextsObject.portOfDischarge,
    },
    {
      field: 'column5',
      filterType: 'string',
      title: translatedTextsObject.portOfDestinationExit
    },
    {
      field: 'column6',
      filterType: 'string',
      title: translatedTextsObject.hblStatusReleased
    },
    {
      field: 'column7',
      filterType: 'string',
      title: translatedTextsObject.masterReferenceNumber
    }
  ]

  //isf10 column
  //1 - id
  //2 - cbp transaction number
  //3 - status
  //4 - importer document number
  //5 - shipment reference number
  //6 - reference booking number
  const isf10TableCols = [
    {
      field: 'column4',
      filterType: 'string',
      title: translatedTextsObject.importerDocumentNumber,
      render: (data) => {
        var status = data.column3
        var recordId = data.column1
        var viewUrl = `/ace-isf/isf10/view/`+ recordId
        var editUrl = `/ace-isf/isf10/edit/`+ recordId

        return (
          <div style={{ 'text-decoration': 'underline', cursor: 'pointer' }}
            onClick={() => { status === "ST" ? history.push(viewUrl) : history.push(editUrl) }}>
            {data.column4}
          </div>
        )
      }
    },
    {
      field: 'column5',
      filterType: 'string',
      title: translatedTextsObject.shipmentReferenceNumber,
    },
    {
      field: 'column3',
      filterType: 'checkbox',
      filterOptions: [
      {
        label: translatedTextsObject.draft,
        value: 'DR'
      },
      {
        label: translatedTextsObject.accepted,
        value: 'AC'
      },
      {
        label: translatedTextsObject.sent,
        value: 'ST'
      },
      {
        label: translatedTextsObject.rejected,
        value: 'RJ'
      },
      {
        label: translatedTextsObject.statusNotification,
        value: 'SN'
      },
      {
        label: translatedTextsObject.cancellationAccepted,
        value: 'CL'
      },
      {
        label: translatedTextsObject.cancellationRejected,
        value: 'CR'
      },
      {
        label: translatedTextsObject.modificationRejected,
        value: 'MR'
      }
    ],
      title: translatedTextsObject.status,
      render: (data) => {

        const statusIndicator = data.column3 
        
        const status = getStatusMetadata(statusIndicator)

        return (
            <Chip
              label={status.label}
              size='small'
              style={{ backgroundColor: status.color, color: status.contrastColor }}
            />
        )
      }
    },
    {
      field: 'column2',
      filterType: 'string',
      title: translatedTextsObject.transactionId
    },
    {
      field: 'column6',
      filterType: 'string',
      title: translatedTextsObject.referenceBookingNumber
    }
  ]

  //aciocean a6a column
  //1 - id
  //2 - doc format (form type)
  //3 - ccn
  //4 - customs procedure
  //5 - status (raw integer code string)
  //6 - message function
  //eta - created date
  const aciOceanTableCols = [
    {
      field: 'column2',
      filterType: 'checkbox',
      filterOptions: [
        { label: translatedTextsObject.aciOceanDocTypeImport,       value: '83'  },
        { label: translatedTextsObject.aciOceanDocTypeExport,       value: '711' },
        { label: translatedTextsObject.aciOceanDocTypeEmpty,        value: '695' },
        { label: translatedTextsObject.aciOceanDocTypeSupplementary, value: '687' },
      ],
      title: translatedTextsObject.aciOceanFormType,
      render: (data) => (
        <Typography component='div' variant='inherit'>
          {getLookupValue('aciOcnDocFormat', data.column2)}
        </Typography>
      )
    },
    {
      field: 'column3',
      filterType: 'string',
      title: translatedTextsObject.aciOceanCcn,
      render: (data) => {
        var status = data.column5
        var recordId = data.column1
        // 1048 = Send Successfully, 1 = CBSA Received Processing -> view only
        var isSent = (status === '1048' || status === '1')
        var viewUrl = `/aci-ocean/a6a/view/` + recordId
        var editUrl = `/aci-ocean/a6a/edit/` + recordId

        return (
          <div style={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() => { isSent ? history.push(viewUrl) : history.push(editUrl) }}>
            {data.column3}
          </div>
        )
      }
    },
    {
      field: 'column4',
      filterType: 'checkbox',
      filterOptions: [
        { label: translatedTextsObject.aciOceanCustomsProcedureInTransit,     value: '23' },
        { label: translatedTextsObject.aciOceanCustomsProcedureImportedGoods, value: '24' },
        { label: translatedTextsObject.aciOceanCustomsProcedureExportedGoods, value: '25' },
        { label: translatedTextsObject.aciOceanCustomsProcedureFrob,          value: '26' },
      ],
      title: translatedTextsObject.aciOceanCustomsProcedure,
      render: (data) => (
        <Typography component='div' variant='inherit'>
          {getLookupValue('aciOcnCustomsProcedure', data.column4)}
        </Typography>
      )
    },
    {
      field: 'column5',
      filterType: 'checkbox',
      filterOptions: [
        { label: translatedTextsObject.draft,                value: '1005' },
        { label: translatedTextsObject.conveyanceStatus1,    value: '1'    },
        { label: translatedTextsObject.conveyanceStatus1048, value: '1048' },
        { label: translatedTextsObject.conveyanceStatus1049, value: '1049' },
        { label: translatedTextsObject.accepted,             value: '1000' },
        { label: translatedTextsObject.rejected,             value: '1001' },
        { label: translatedTextsObject.cancellationAccepted, value: '1003' },
        { label: translatedTextsObject.cancellationRejected, value: '1004' },
        { label: translatedTextsObject.conveyanceStatus17,   value: '17'   },
        { label: translatedTextsObject.conveyanceStatus200,  value: '200'  },
        { label: translatedTextsObject.conveyanceStatus25,   value: '25'   },
        { label: translatedTextsObject.conveyanceStatus14,   value: '14'   },
        { label: translatedTextsObject.conveyanceStatus28,   value: '28'   },
        { label: translatedTextsObject.conveyanceStatus29,   value: '29'   },
        { label: translatedTextsObject.conveyanceStatus20,   value: '20'   },
        { label: translatedTextsObject.conveyanceStatus21,   value: '21'   },
        { label: translatedTextsObject.conveyanceStatus22,   value: '22'   },
        { label: translatedTextsObject.conveyanceStatus32,   value: '32'   },
        { label: translatedTextsObject.conveyanceStatus33,   value: '33'   },
      ],
      title: translatedTextsObject.status,
      render: (data) => {
        const status = getStatusMetadata(data.column5)
        return (
          <Chip
            label={status.label}
            size='small'
            style={{ backgroundColor: status.color, color: status.contrastColor }}
          />
        )
      }
    },
    {
      field: 'column6',
      filterType: 'checkbox',
      filterOptions: [
        { label: translatedTextsObject.aciOceanMsgFunctionOriginal, value: '9' },
        { label: translatedTextsObject.aciOceanMsgFunctionChange,   value: '4' },
        { label: translatedTextsObject.aciOceanMsgFunctionCancel,   value: '1' },
      ],
      title: translatedTextsObject.aciOceanMessageFunction,
      render: (data) => (
        <Typography component='div' variant='inherit'>
          {getLookupValue('aciOcnMessageFunction', data.column6)}
        </Typography>
      )
    },
    {
      field: 'eta',
      filterType: 'string',
      title: translatedTextsObject.aciOceanCreatedDate,
      render: (data) => data.eta && moment(data.eta).tz('Canada/Eastern').format('D MMM YYYY, HH:mm')
    }
  ]


  //aceocean column
  const aceOceanTableCols = [
    {
      field: 'column2',
      filterType: 'string',
      title: translatedTextsObject.scac,
      render: (data) => {
        var status = data.column5
        var recordId = data.column1
        var viewUrl = `/ace-ocean/manifest/view/`+ recordId
        var editUrl = `/ace-ocean/manifest/edit/`+ recordId

        return (
          <div style={{ 'text-decoration': 'underline', cursor: 'pointer' }}
            onClick={() => { status === "ST" ? history.push(viewUrl) : history.push(editUrl) }}>
            {data.column2}
          </div>
        )
      }
    },
    {
      field: 'column5',
      filterType: 'checkbox',
      filterOptions: [
      {
        label: translatedTextsObject.draft,
        value: 'DR'
      },
      {
        label: translatedTextsObject.accepted,
        value: 'AC'
      },
      {
        label: translatedTextsObject.sent,
        value: 'ST'
      },
      {
        label: translatedTextsObject.rejected,
        value: 'RJ'
      },
      {
        label: translatedTextsObject.statusNotification,
        value: 'SN'
      },
      {
        label: translatedTextsObject.cancellationAccepted,
        value: 'CL'
      },
      {
        label: translatedTextsObject.cancellationRejected,
        value: 'CR'
      },
      {
        label: translatedTextsObject.modificationRejected,
        value: 'MR'
      }
    ],
      title: translatedTextsObject.status,
      render: (data) => {

        const statusIndicator = data.column5 
        
        const status = getStatusMetadata(statusIndicator)

        return (
            <Chip
              label={status.label}
              size='small'
              style={{ backgroundColor: status.color, color: status.contrastColor }}
            />
        )
      }
    },
    {
      field: 'eta',
      filterType: 'string',
      title: translatedTextsObject.eta,
      render: (data) => data.eta && moment(data.eta).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'column3',
      filterType: 'string',
      title: translatedTextsObject.vesselName,
    },
    {
      field: 'column4',
      filterType: 'string',
      title: translatedTextsObject.voyageNumber,
    },
    {
      field: 'column6',
      filterType: 'string',
      title: translatedTextsObject.port
    }
  ]

  
  const ENTRY_TYPE_MAP = {
    '01': translatedTextsObject.entryType01,
    '02': translatedTextsObject.entryType02,
    '03': translatedTextsObject.entryType03,
    '07': translatedTextsObject.entryType07,
    '11': translatedTextsObject.entryType11,
    '12': translatedTextsObject.entryType12,
    '21': translatedTextsObject.entryType21,
    '23': translatedTextsObject.entryType23,
    '52': translatedTextsObject.entryType52,
    '61': translatedTextsObject.entryType61,
    '62': translatedTextsObject.entryType62
  };

  const BILL_TYPE_MAP = {
    'M': translatedTextsObject.billTypeM,
    'R': translatedTextsObject.billTypeR,
    'T': translatedTextsObject.billTypeT,
  };

  //fdapn column
  const fdapnTableCols = [
    {
      field: 'column2',
      filterType: 'string',
      title: translatedTextsObject.referenceNumber,
      render: (data) => {
        var status = data.column5
        var recordId = data.column1
        var viewUrl = `/fda-pn/view/`+ recordId
        var editUrl = `/fda-pn/edit/`+ recordId

        return (
          <div style={{ 'text-decoration': 'underline', cursor: 'pointer' }}
            onClick={() => { status === "ST" ? history.push(viewUrl) : history.push(editUrl) }}>
            {data.column2}
          </div>
        )
      }
    },
    {
      field: 'column3',
      filterType: 'checkbox',
      title: translatedTextsObject.entryType,
      filterOptions: [
      {
        label: translatedTextsObject.entryType01,
        value: '01'
      },
      {
        label: translatedTextsObject.entryType02,
        value: '02'
      },
      {
        label: translatedTextsObject.entryType03,
        value: '03'
      },
      {
        label: translatedTextsObject.entryType07,
        value: '07'
      },
      {
        label: translatedTextsObject.entryType11,
        value: '11'
      },
      {
        label: translatedTextsObject.entryType12,
        value: '12'
      },
      {
        label: translatedTextsObject.entryType21,
        value: '21'
      },
      {
        label: translatedTextsObject.entryType23,
        value: '23'
      },
      {
        label: translatedTextsObject.entryType52,
        value: '52'
      },
      {
        label: translatedTextsObject.entryType61,
        value: '61'
      },
      {
        label: translatedTextsObject.entryType62,
        value: '62'
      }],
      render: (data) =>
        <Typography component='div' variant='inherit'>
          {getLookupValue('entryType', data.column3)}
        </Typography>
    },
    {
      field: 'column4',
      filterType: 'checkbox',
      title: translatedTextsObject.billType,
      filterOptions: [
      {
        label: translatedTextsObject.billTypeM,
        value: 'M'
      },
      {
        label: translatedTextsObject.billTypeR,
        value: 'R'
      },
      {
        label: translatedTextsObject.billTypeT,
        value: 'T'
      }],
      render: (data) =>
        <Typography component='div' variant='inherit'>
          {getLookupValue('billType', data.column4)}
        </Typography>
    },
    {
      field: 'column6',
      filterType: 'string',
      title: translatedTextsObject.arrivalLocation,
    },
    {
      field: 'eta',
      filterType: 'string',
      title: translatedTextsObject.anticipatedArrivalDate,
      render: (data) => combineDateAndTime(data.eta, data.column7)
    },
    {
      field: 'column5',
      filterType: 'checkbox',
      filterOptions: [
      {
        label: translatedTextsObject.draft,
        value: 'DR'
      },
      {
        label: translatedTextsObject.accepted,
        value: 'AC'
      },
      {
        label: translatedTextsObject.sent,
        value: 'ST'
      },
      {
        label: translatedTextsObject.rejected,
        value: 'RJ'
      },
      {
        label: translatedTextsObject.statusNotification,
        value: 'SN'
      },
      {
        label: translatedTextsObject.cancellationAccepted,
        value: 'CL'
      },
      {
        label: translatedTextsObject.cancellationRejected,
        value: 'CR'
      },
      {
        label: translatedTextsObject.modificationRejected,
        value: 'MR'
      }
    ],
      title: translatedTextsObject.status,
      render: (data) => {

        const statusIndicator = data.column5 
        
        const status = getStatusMetadata(statusIndicator)

        return (
            <Chip
              label={status.label}
              size='small'
              style={{ backgroundColor: status.color, color: status.contrastColor }}
            />
        )
      }
    }
  ]

  const abiTableCols = [
    {
      field: 'referenceNumber',
      filterType: 'string',
      title: 'Reference Number',
      render: (data) => {
        var status = data.status
        var recordId = data.id
        var viewUrl = `/abi/entry-summary/view/` + recordId
        var editUrl = `/abi/entry-summary/edit/` + recordId
        return (
          <div style={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() => { status === "Sent" ? history.push(viewUrl) : history.push(editUrl) }}>
            {data.referenceNumber}
          </div>
        )
      }
    },
    {
      field: 'messageType',
      filterType: 'string',
      title: 'Message Type'
    },
    {
      field: 'status',
      filterType: 'checkbox',
      filterOptions: [
        { label: 'Accepted', value: 'Accepted' },
        { label: 'Rejected', value: 'Rejected' },
        { label: 'Sent', value: 'Sent' },
        { label: 'Hold', value: 'Hold' }
      ],
      title: 'Status',
      render: (data) => {
        if (!data.status) return '-'
        const status = getStatusMetadata(data.status)
        return (
          <Chip
            label={data.status}
            size='small'
            style={{ backgroundColor: status.color, color: status.contrastColor }}
          />
        )
      }
    },
    {
      field: 'submittedTime',
      filterType: 'date',
      title: 'Submitted Time',
      render: (data) => data.submittedTime && moment(data.submittedTime).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    }
  ]

  const abiQueryTableCols = [
    {
      field: 'reference',
      filterType: 'string',
      title: 'Reference',
      render: (data) => {
        return (
          <div style={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() => history.push(pathMap.ABI_QUERY_LIST_VIEW, {
              openQuery: { reference: data.reference, submittedTime: data.submittedTime }
            })}>
            {data.reference}
          </div>
        )
      }
    },
    {
      field: 'queryType',
      filterType: 'string',
      title: 'Query Type'
    },
    {
      field: 'status',
      filterType: 'checkbox',
      filterOptions: [
        { label: 'Accepted', value: 'Accepted' },
        { label: 'Rejected', value: 'Rejected' },
        { label: 'Sent', value: 'Sent' }
      ],
      title: 'Status',
      render: (data) => {
        if (!data.status) return '-'
        const status = getStatusMetadata(data.status)
        return (
          <Chip
            label={data.status}
            size='small'
            style={{ backgroundColor: status.color, color: status.contrastColor }}
          />
        )
      }
    },
    {
      field: 'submittedTime',
      filterType: 'date',
      title: 'Submitted Time',
      render: (data) => data.submittedTime && moment(data.submittedTime).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'receivedTime',
      filterType: 'date',
      title: 'Received Time',
      render: (data) => data.receivedTime && moment(data.receivedTime).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    }
  ]

  const MESSAGE_FUNCTION_MAP = {
    '1': translatedTextsObject.msgFunctionCancel,
    '4': translatedTextsObject.msgFunctionModify,
    '9': translatedTextsObject.msgFunctionAdd,
  };

  const ACI_OCEAN_DOC_FORMAT_MAP = {
    '83':  translatedTextsObject.aciOceanDocTypeImport,
    '711': translatedTextsObject.aciOceanDocTypeExport,
    '695': translatedTextsObject.aciOceanDocTypeEmpty,
    '687': translatedTextsObject.aciOceanDocTypeSupplementary,
  };

  const ACI_OCEAN_CUSTOMS_PROCEDURE_MAP = {
    '23': translatedTextsObject.aciOceanCustomsProcedureInTransit,
    '24': translatedTextsObject.aciOceanCustomsProcedureImportedGoods,
    '25': translatedTextsObject.aciOceanCustomsProcedureExportedGoods,
    '26': translatedTextsObject.aciOceanCustomsProcedureFrob,
  };

  const ACI_OCEAN_MESSAGE_FUNCTION_MAP = {
    '9': translatedTextsObject.aciOceanMsgFunctionOriginal,
    '4': translatedTextsObject.aciOceanMsgFunctionChange,
    '1': translatedTextsObject.aciOceanMsgFunctionCancel,
  };

  const WACM_STATUS_MAP = {
    'DR': translatedTextsObject.draft,
    'ST': translatedTextsObject.sent,
    'MCA': translatedTextsObject.messageContentAccepted,
    'MCR': translatedTextsObject.messageContentRejected,
    'GR': translatedTextsObject.goodsReleased,
    'GRE': translatedTextsObject.goodsRequiredExamination,
    'GMM': translatedTextsObject.goodsMayMove,
    'DAA': translatedTextsObject.declarationAcceptedGoods,
    'EM': translatedTextsObject.errorMessage,
    'ADC': translatedTextsObject.authorisedToDeliver,
    'DAC': translatedTextsObject.declarationAcceptedProcessing,
    'DAW': translatedTextsObject.declarationAcceptedWarnings
  };
  //wacm column
  const wacmTableCols = [
    {
      field: 'column2',
      filterType: 'string',
      title: translatedTextsObject.cargoControlNumber,
      render: (data) => {
        var status = data.column5
        var recordId = data.column1
        var viewUrl = `/aci-highway/inbond/view/`+ recordId
        var editUrl = `/aci-highway/inbond/edit/`+ recordId

        return (
          <div style={{ 'text-decoration': 'underline', cursor: 'pointer' }}
            onClick={() => { status === "ST" ? history.push(viewUrl) : history.push(editUrl) }}>
            {data.column2}
          </div>
        )
      }
    },
    {
      field: 'column4',
      filterType: 'checkbox',
      title: translatedTextsObject.messageFunction,
      filterOptions: [
      {
        label: translatedTextsObject.msgFunctionCancel,
        value: '1'
      },
      {
        label: translatedTextsObject.msgFunctionModify,
        value: '4'
      },
      {
        label: translatedTextsObject.msgFunctionAdd,
        value: '9'
      }],
      render: (data) =>
        <Typography component='div' variant='inherit'>
          {getLookupValue('msgFunction', data.column4)}
        </Typography>
    },
    {
      field: 'column3',
      filterType: 'string',
      title: translatedTextsObject.destinationOfficeCode,
    },
    {
      field: 'column5',
      filterType: 'checkbox',
      filterOptions: [
      {
        label: translatedTextsObject.draft,
        value: 'DR'
      },
      {
        label: translatedTextsObject.sent,
        value: 'ST'
      },
      {
        label: translatedTextsObject.messageContentAccepted,
        value: 'MCA'
      },
      {
        label: translatedTextsObject.messageContentRejected,
        value: 'MCR'
      },
      {
        label: translatedTextsObject.goodsReleased,
        value: 'GR'
      },
      {
        label: translatedTextsObject.goodsRequiredExamination,
        value: 'GRE'
      },
      {
        label: translatedTextsObject.goodsMayMove,
        value: 'GMM'
      },
      {
        label: translatedTextsObject.declarationAcceptedGoods,
        value: 'DAA'
      },
      {
        label: translatedTextsObject.errorMessage,
        value: 'EM'
      },
      {
        label: translatedTextsObject.authorisedToDeliver,
        value: 'ADC'
      },
      {
        label: translatedTextsObject.declarationAcceptedProcessing,
        value: 'DAC'
      },
      {
        label: translatedTextsObject.declarationAcceptedWarnings,
        value: 'DAW'
      },
    ],
      title: translatedTextsObject.status,
      render: (data) => {

        const statusIndicator = data.column8 
        
        const status = getStatusMetadata(statusIndicator)

        return (
            <Chip
              label={getLookupValue('wacmStatus', data.column5)}
              size='small'
              style={{ backgroundColor: status.color, color: status.contrastColor }}
            />
        )
      }
    },
    {
      field: 'eta',
      filterType: 'string',
      title: translatedTextsObject.createdDate,
      render: (data) => data.eta && moment(data.eta).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'column6',
      filterType: 'string',
      title: translatedTextsObject.error
    }
  ]

  //aciair column
  const aciairTableCols = [
    {
      field: 'column2',
      filterType: 'string',
      title: translatedTextsObject.conveyanceRefNo,
      render: (data) => {
        var status = data.column5
        var recordId = data.column1
        var viewUrl = `/aci-air/conveyance/view/`+ recordId
        var editUrl = `/aci-air/conveyance/edit/`+ recordId

        return (
          <div style={{ 'text-decoration': 'underline', cursor: 'pointer' }}
            onClick={() => { status === "ST" ? history.push(viewUrl) : history.push(editUrl) }}>
            {data.column2}
          </div>
        )
      }
    },
    {
      field: 'column3',
      filterType: 'string',
      title: translatedTextsObject.carrierCode,
    },
    {
      field: 'column4',
      filterType: 'string',
      title: translatedTextsObject.flightNo,
    },
    {
      field: 'column6',
      filterType: 'string',
      title: translatedTextsObject.departurePort,
    },
    {
      field: 'column7',
      filterType: 'string',
      title: translatedTextsObject.arrivalPort,
    },
    {
      field: 'eta',
      filterType: 'string',
      title: translatedTextsObject.createdDate,
      render: (data) => data.eta && moment(data.eta).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'column5',
      filterType: 'checkbox',
      filterOptions: [
      {
        label: translatedTextsObject.draft,
        value: 'DR'
      },
      {
        label: translatedTextsObject.accepted,
        value: '1000'
      },
      {
        label: translatedTextsObject.rejected,
        value: 'RJ'
      },
      {
        label: translatedTextsObject.cancellationAccepted,
        value: 'CL'
      },
      {
        label: translatedTextsObject.cancellationRejected,
        value: 'CR'
      },
      {
        label: translatedTextsObject.conveyanceStatus1,
        value: '1'
      },
      {
        label: translatedTextsObject.conveyanceStatus1048,
        value: '1048'
      },
      {
        label: translatedTextsObject.conveyanceStatus1049,
        value: '1049'
      },
      {
        label: translatedTextsObject.conveyanceStatus17,
        value: '17'
      },
      {
        label: translatedTextsObject.conveyanceStatus200,
        value: '200'
      },
      {
        label: translatedTextsObject.conveyanceStatus25,
        value: '25'
      },
      {
        label: translatedTextsObject.conveyanceStatus14,
        value: '14'
      },
      {
        label: translatedTextsObject.conveyanceStatus28,
        value: '28'
      },
      {
        label: translatedTextsObject.conveyanceStatus29,
        value: '29'
      },
      {
        label: translatedTextsObject.conveyanceStatus20,
        value: '20'
      },
      {
        label: translatedTextsObject.conveyanceStatus21,
        value: '21'
      },
      {
        label: translatedTextsObject.conveyanceStatus22,
        value: '22'
      },
      {
        label: translatedTextsObject.conveyanceStatus32,
        value: '32'
      },
      {
        label: translatedTextsObject.conveyanceStatus33,
        value: '33'
      },

    ],
      title: translatedTextsObject.status,
      render: (data) => {

        const statusIndicator = data.column5 
        
        const status = getStatusMetadata(statusIndicator)

        return (
            <Chip
              label={status.label}
              size='small'
              style={{ backgroundColor: status.color, color: status.contrastColor }}
            />
        )
      }
    }
  ]

  //aes column
  const aesTableCols = [
    {
      field: 'column2',
      filterType: 'string',
      title: translatedTextsObject.shipmentReferenceNumber,
      render: (data) => {
        var status = data.column5
        var recordId = data.column1
        var viewUrl = `/aes/shipment/view/`+ recordId
        var editUrl = `/aes/shipment/edit/`+ recordId

        return (
          <div style={{ 'text-decoration': 'underline', cursor: 'pointer' }}
            onClick={() => { status === "ST" ? history.push(viewUrl) : history.push(editUrl) }}>
            {data.column2}
          </div>
        )
      }
    },
    {
      field: 'column5',
      filterType: 'checkbox',
      filterOptions: [
      {
        label: translatedTextsObject.draft,
        value: '1005'
      },
      {
        label: translatedTextsObject.accepted,
        value: '1000'
      },
      {
        label: translatedTextsObject.sent,
        value: '1008'
      },
      {
        label: translatedTextsObject.rejected,
        value: '1001'
      },
      {
        label: translatedTextsObject.statusNotification,
        value: '1006'
      },
      {
        label: translatedTextsObject.cancellationAccepted,
        value: '1003'
      },
      {
        label: translatedTextsObject.cancellationRejected,
        value: '1004'
      },
      {
        label: translatedTextsObject.replaceRejected,
        value: '1007'
      },
      {
        label: translatedTextsObject.modificationRejected,
        value: '1009'
      }
    ],
      title: translatedTextsObject.status,
      render: (data) => {
        
        const status = getStatusMetadataMini(data.column5)

        return (
            <Chip
              label={status.label}
              size='small'
              style={{ backgroundColor: status.color, color: status.contrastColor }}
            />
        )
      }
    },
    {
      field: 'column3',
      filterType: 'string',
      title: translatedTextsObject.shipperName,
    },
    {
      field: 'column4',
      filterType: 'string',
      title: translatedTextsObject.consigneeName,
    },
    {
      field: 'column6',
      filterType: 'string',
      title: translatedTextsObject.entryNumber,
    },
    {
      field: 'column7',
      filterType: 'string',
      title: translatedTextsObject.cbpItnNo,
    },
    {
      field: 'eta',
      filterType: 'string',
      title: translatedTextsObject.createdDate,
      render: (data) => data.eta && moment(data.eta).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    }
  ]


  return (
    <Grid container spacing={2}>
      {showAceHighway && 
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DoughnutChart
                title={aceManifestTitle}
                endpoint={`${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}` + '/ace-highway/dashboard/all-transaction-status'}
                onChartElementClicked={onChartElementClicked}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Table
                columns={aceManifestsTableCols}
                title={aceManifestSortedTitle}
                onClickActionButton={() =>
                  history.push(pathMap.ACE_HIGHWAY_MANIFEST_LIST_VIEW, { fetchAll: true })
                }
                endpoint={`${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}` + '/ace-highway/dashboard/manifest-by-submitted-date'}
                clickedChartStatus={clickedChartStatus}
              />
            </Grid>
          </Grid>
        </Grid>
      }
      {showAciHighway && 
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DoughnutChart
                title={aciManifestTitle}
                endpoint={`${process.env.REACT_APP_USER_ACIHW_URL}` + '/aci-highway/dashboard/all-transaction-status'}
                onChartElementClicked={onChartElementClicked}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Table
                columns={aciManifestsTableCols}
                title={aciManifestSortedTitle}
                onClickActionButton={() =>
                  history.push(pathMap.ACIHWY_MANIFEST_LIST_VIEW, { fetchAll: true })
                }
                endpoint={`${process.env.REACT_APP_USER_ACIHW_URL}` + '/aci-highway/dashboard/manifest-by-submitted-date'}
                clickedChartStatus={clickedChartStatus}
              />
            </Grid>
          </Grid>
        </Grid>
      }
      {showEhbl && 
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DoughnutChart
                title={translatedTextsObject.ehblManifestTitle}
                endpoint={DashboardApiUrls.EHBL_GET_ALL_TRANSACTION_STATUS}
                onChartElementClicked={onChartElementClicked}
                //overwrite status from AC to 1000 to display Accepted status
                overwriteStatusMap={{AC: 1000}}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Table
                columns={ehblTableCols}
                title={translatedTextsObject.ehblManifestBySubmittedDateTitle}
                onClickActionButton={() =>
                  history.push(pathMap.EHBL_MANIFEST_LIST_VIEW, { fetchAll: true })
                }
                endpoint={DashboardApiUrls.EHBL_GET_MANIFEST_BY_SUBMITTED_DATE}
                clickedChartStatus={clickedChartStatus}
              />
            </Grid>
          </Grid>
        </Grid>
     }

     {showISF10 && 
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DoughnutChart
                title={translatedTextsObject.isf10Title}
                endpoint={DashboardApiUrls.ISF10_GET_ALL_TRANSACTION_STATUS}
                onChartElementClicked={onChartElementClicked}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Table
                columns={isf10TableCols}
                title={translatedTextsObject.isf10BySubmittedDateTitle}
                onClickActionButton={() =>
                  history.push(pathMap.ACEISF10_LIST_VIEW, { fetchAll: true })
                }
                endpoint={DashboardApiUrls.ISF10_GET_MANIFEST_BY_SUBMITTED_DATE}
                clickedChartStatus={clickedChartStatus}
                seeAllButtonLabel={translatedTextsObject.seeAllRecords}
              />
            </Grid>
          </Grid>
        </Grid>
     }

     {showAciOcean && 
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DoughnutChart
                title={translatedTextsObject.aciOceanTitle}
                endpoint={DashboardApiUrls.ACIOCN_GET_ALL_TRANSACTION_STATUS}
                onChartElementClicked={onChartElementClicked}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Table
                columns={aciOceanTableCols}
                title={translatedTextsObject.aciOceanBySubmittedDateTitle}
                onClickActionButton={() =>
                  history.push(pathMap.A6A_LIST_VIEW, { fetchAll: true })
                }
                endpoint={DashboardApiUrls.ACIOCN_GET_MANIFEST_BY_SUBMITTED_DATE}
                clickedChartStatus={clickedChartStatus}
                seeAllButtonLabel={translatedTextsObject.seeAllRecords}
              />
            </Grid>
          </Grid>
        </Grid>
     }

     {showAceOcean && 
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DoughnutChart
                title={translatedTextsObject.aceOceanTitle}
                endpoint={DashboardApiUrls.ACEOCN_GET_ALL_TRANSACTION_STATUS}
                onChartElementClicked={onChartElementClicked}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Table
                columns={aceOceanTableCols}
                title={translatedTextsObject.aceOceanBySubmittedDateTitle}
                onClickActionButton={() =>
                  history.push(pathMap.ACE_OCN_MANIFEST_LIST_VIEW, { fetchAll: true })
                }
                endpoint={DashboardApiUrls.ACEOCN_GET_MANIFEST_BY_SUBMITTED_DATE}
                clickedChartStatus={clickedChartStatus}
                seeAllButtonLabel={translatedTextsObject.seeAllManifests}
              />
            </Grid>
          </Grid>
        </Grid>
     }

     {showFDAPN && 
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DoughnutChart
                title={translatedTextsObject.fdapnTitle}
                endpoint={DashboardApiUrls.FDAPN_GET_ALL_TRANSACTION_STATUS}
                onChartElementClicked={onChartElementClicked}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Table
                columns={fdapnTableCols}
                title={translatedTextsObject.fdapnBySubmittedDateTitle}
                onClickActionButton={() =>
                  history.push(pathMap.FDAPN_LIST_VIEW, { fetchAll: true })
                }
                endpoint={DashboardApiUrls.FDAPN_GET_MANIFEST_BY_SUBMITTED_DATE}
                clickedChartStatus={clickedChartStatus}
                seeAllButtonLabel={translatedTextsObject.seeAllRecords}
              />
            </Grid>
          </Grid>
        </Grid>
     }

     {showWACM && 
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DoughnutChart
                title={translatedTextsObject.wacmTitle}
                endpoint={DashboardApiUrls.WACM_GET_ALL_TRANSACTION_STATUS}
                onChartElementClicked={onChartElementClicked}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Table
                columns={wacmTableCols}
                title={translatedTextsObject.wacmBySubmittedDateTitle}
                onClickActionButton={() =>
                  history.push(pathMap.WACM_MMANIFEST_FORWARD, { fetchAll: true })
                }
                endpoint={DashboardApiUrls.WACM_GET_MANIFEST_BY_SUBMITTED_DATE}
                clickedChartStatus={clickedChartStatus}
                seeAllButtonLabel={translatedTextsObject.seeAllRecords}
              />
            </Grid>
          </Grid>
        </Grid>
     }

     {showAciAir && 
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DoughnutChart
                title={translatedTextsObject.aciAirTitle}
                endpoint={DashboardApiUrls.ACIAIR_GET_ALL_TRANSACTION_STATUS}
                onChartElementClicked={onChartElementClicked}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Table
                columns={aciairTableCols}
                title={translatedTextsObject.aciAirBySubmittedDateTitle}
                onClickActionButton={() =>
                  history.push(pathMap.CONVEYANCE_LIST_VIEW, { fetchAll: true })
                }
                endpoint={DashboardApiUrls.ACIAIR_GET_MANIFEST_BY_SUBMITTED_DATE}
                clickedChartStatus={clickedChartStatus}
                seeAllButtonLabel={translatedTextsObject.seeAllRecords}
              />
            </Grid>
          </Grid>
        </Grid>
     }

     {showAES && 
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DoughnutChart
                title={translatedTextsObject.aesTitle}
                endpoint={DashboardApiUrls.AES_GET_ALL_TRANSACTION_STATUS}
                onChartElementClicked={onChartElementClicked}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Table
                columns={aesTableCols}
                title={translatedTextsObject.aesBySubmittedDateTitle}
                onClickActionButton={() =>
                  history.push(pathMap.AES_SHIPMENT_LIST_VIEW, { fetchAll: true })
                }
                endpoint={DashboardApiUrls.AES_GET_MANIFEST_BY_SUBMITTED_DATE}
                clickedChartStatus={clickedChartStatus}
                seeAllButtonLabel={translatedTextsObject.seeAllRecords}
              />
            </Grid>
          </Grid>
        </Grid>
     }

     {showABI &&
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <ABIDoughNutChart
                title="ABI Entry Summary"
                endpoint={DashboardApiUrls.ABI_GET_ALL_TRANSACTION_STATUS}
                onChartElementClicked={onChartElementClicked}
                dataTransformer={(data) => {
                  const mapping = {}
                  const breakdown = data && data.data && data.data.statusBreakdown
                  if (breakdown) {
                    breakdown.forEach(item => {
                      if (item.count > 0) mapping[item.status] = item.count
                    })
                  }
                  return mapping
                }}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <ABITable
                columns={abiTableCols}
                title="ABI Entry Summary (Sorted by submitted date)"
                requestParams={{ pageSize: 30, sortBy: 'submittedTime', sortOrder: 'DESC' }}
                onClickActionButton={() =>
                  history.push(pathMap.ABI_TRANSACTION_LIST_VIEW, { fetchAll: true })
                }
                endpoint={DashboardApiUrls.ABI_GET_MANIFEST_BY_SUBMITTED_DATE}
                clickedChartStatus={clickedChartStatus}
                seeAllButtonLabel="See all records"
                dataTransformer={(data) => (data && data.data && data.data.transactions) || []}
              />
            </Grid>
          </Grid>
        </Grid>
     }

     {showABIQuery &&
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <ABIDoughNutChart
                title="ABI Query"
                endpoint={DashboardApiUrls.ABI_QUERY_GET_ALL_TRANSACTION_STATUS}
                onChartElementClicked={onChartElementClicked}
                dataTransformer={(data) => {
                  const mapping = {}
                  const breakdown = data && data.data && data.data.statusBreakdown
                  if (breakdown) {
                    breakdown.forEach(item => {
                      if (item.count > 0) mapping[item.status] = item.count
                    })
                  }
                  return mapping
                }}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <ABITable
                columns={abiQueryTableCols}
                title="ABI Query (Sorted by submitted date)"
                requestParams={{ pageSize: 30, sortBy: 'submittedTime', sortOrder: 'DESC' }}
                onClickActionButton={() =>
                  history.push(pathMap.ABI_QUERY_LIST_VIEW, { fetchAll: true })
                }
                endpoint={DashboardApiUrls.ABI_QUERY_GET_MANIFEST_BY_SUBMITTED_DATE}
                clickedChartStatus={clickedChartStatus}
                seeAllButtonLabel="See all records"
                dataTransformer={(data) => (data && data.data && data.data.transactions) || []}
              />
            </Grid>
          </Grid>
        </Grid>
     }

      <QuickGlanceDialog
        data={quickGlanceDialog.data}
        onClose={() => setQuickGlanceDialog({ open: false, data: null, isAce: quickGlanceDialog.isAce })}
        open={quickGlanceDialog.open}
        isAce={quickGlanceDialog.isAce}
        history={history}
      />
    </Grid>
  )
}

export default SummaryPage


function QuickGlanceDialog(props) {
  const { data, open, onClose, isAce, history } = props
  const [redirectUrl, setRedirectUrl] = useState()

  const title = isAce ? 'Quick Glance at Shipment(s)' : 'Quick Glance at Cargo(s)'
  const redirectData = { manifestData: { ...data }, step: "2" }

  useEffect(() => {
    if (!data) return

    let endpoint = data.status == 'ST' ? '/manifest/view/' : '/manifest/edit/'
    if (isAce) {
      endpoint = '/ace-highway' + endpoint + data.manifestID

    } else {
      endpoint = '/aci-highway' + endpoint + data.manifestID
    }
    setRedirectUrl(endpoint)
  }, [data])

  function getDialogAction() {
    let buttonLabel = isAce ? 'View All Attached Shipments' : 'View All Attached Cargos'

    return data && data.status != 'ST' ?
      <CngButton onClick={() => history.push(redirectUrl, redirectData)} color='secondary'>
        {buttonLabel}
      </CngButton>
      : null
  }

  let content = data ? (
    <Grid>
      {isAce &&
        <SummaryShipmentTable manifestId={data.manifestID} manifestPort={data.port} />
      }

      {!isAce &&
        <SummaryCargoTable manifestId={data.manifestID} />
      }
    </Grid>
  ) : null

  return (
    <CngDialog
      dialogTitle={title}
      dialogContent={content}
      dialogAction={getDialogAction(data)}
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      fullWidth
      maxWidth='lg'
      onClose={onClose}
      open={open}
      shouldShowCloseButton
    />
  )
}
